import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function PatientListDialog({ open, setOpen, data, message }) {
  const navigate = useNavigate();
  const [patientId, setPatientId] = useState('')
  const [patientInfo, setPatientInfo] = useState('')

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    localStorage.removeItem('session_id');
    localStorage.setItem('patient_id', JSON.stringify(patientId));
    localStorage.setItem('patient_name', JSON.stringify(patientInfo?.name));

    handleClose();
    // navigate("/chat");
  };

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="sm"
        className="patientList"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <Typography variant="smSize" className="fw-600 black-color-5">
            Choose the correct patient
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography variant="xxsSize" className="fw-500 black-color-2">
            {" "}
            {message}
          </Typography>
          {Array.isArray(data) && data.map((dt, i) => {
            return (
              <>

                <FormGroup className="patient-list" key={i}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={dt?.id}
                        onChange={() => {
                          setPatientId(dt?.id);
                          setPatientInfo(dt);
                        }}
                      />
                    }
                    variant="xxxxsSize"
                    className="fw-500 black-color-2"
                    label={dt?.name}
                  //   label={"John Doe (DOB: 12 March 1985) – Patient ID: JD1985"}
                  />
                </FormGroup>
              </>
            );
          })}
        </DialogContent>
        {patientId && (<>
          <DialogActions sx={{ margin: 'auto' }}>
            <Button onClick={onSubmit} className="submit-button" disabled={!patientId ? true : false}>Submit</Button>
          </DialogActions>
        </>)}

      </Dialog>
    </>
  );
}